module.exports = __webpack_public_path__ + "img/icon_manejo_de_pago.63a244fe.svg";